import { Inject } from '@angular/core';
import templateSource from './view.html';
              import { Component } from '@angular/core';

import Wiz from 'src/wiz';
let wiz = new Wiz('/wiz').app('component.alert');
import { Input, ElementRef, ViewChild, DoCheck, AfterViewChecked, OnDestroy, HostListener } from '@angular/core';
import { Service } from "src/libs/portal/season/service";

let nextAlertId = 0;

@Component({
    selector: 'wiz-component-alert',
template: templateSource || '',
    styles: [`

/* file: /mnt/data/wiz/project/main/build/src/app/component.alert/view.scss */
:host {
  --alert-surface: #fff;
  --alert-border: #e5ebf4;
  --alert-title: #25334d;
  --alert-text: #6a7890;
  --alert-secondary: #f4f7fb;
  --alert-secondary-hover: #eaf0f7;
}

.alert-overlay {
  position: fixed;
  inset: 0;
  z-index: 11000;
  display: flex;
  align-items: center;
  justify-content: center;
  padding: max(24px, env(safe-area-inset-top)) max(20px, env(safe-area-inset-right)) max(24px, env(safe-area-inset-bottom)) max(20px, env(safe-area-inset-left));
  background: rgba(23, 39, 64, 0.32);
  backdrop-filter: blur(5px);
  overscroll-behavior: contain;
}

.alert-dialog {
  --alert-accent: #2872a6;
  --alert-tint: #edf5fc;
  --alert-action: linear-gradient(105deg, #137db9, #303783);
  width: 100%;
  max-width: 440px;
  max-height: calc(100dvh - 64px);
  display: flex;
  flex-direction: column;
  padding: 28px;
  border: 1px solid var(--alert-border);
  border-radius: 24px;
  outline: none;
  background: var(--alert-surface);
  box-shadow: 0 28px 90px -24px rgba(13, 32, 63, 0.35), 0 4px 18px rgba(13, 32, 63, 0.06);
  animation: alert-appear 0.18s ease-out both;
}

.alert-dialog[data-status=success] {
  --alert-accent: #28876a;
  --alert-tint: #eaf7f1;
}

.alert-dialog[data-status=warning] {
  --alert-accent: #b47b22;
  --alert-tint: #fff5e3;
}

.alert-dialog[data-status=error] {
  --alert-accent: #c45b5e;
  --alert-tint: #fceff0;
  --alert-action: linear-gradient(105deg, #ca6165, #b94c58);
}

.alert-content {
  display: flex;
  align-items: flex-start;
  gap: 17px;
  min-height: 56px;
  min-width: 0;
  overflow-y: auto;
  overscroll-behavior: contain;
}

.alert-symbol {
  display: flex;
  flex: 0 0 52px;
  align-items: center;
  justify-content: center;
  width: 52px;
  height: 52px;
  border-radius: 17px;
  background: var(--alert-tint);
  color: var(--alert-accent);
}

.alert-symbol svg {
  width: 28px;
  height: 28px;
}

.alert-copy {
  flex: 1;
  min-width: 0;
  padding-top: 2px;
}

.alert-title {
  margin: 0 0 7px;
  color: var(--alert-title);
  font-size: 18px;
  font-weight: 750;
  line-height: 1.5;
  letter-spacing: -0.4px;
  overflow-wrap: anywhere;
}

.alert-message {
  margin: 0;
  white-space: pre-line;
  color: var(--alert-text);
  font-size: 14px;
  line-height: 1.85;
  word-break: keep-all;
  overflow-wrap: anywhere;
}

.alert-message.is-standalone {
  padding-top: 8px;
  color: var(--alert-title);
  font-size: 16px;
  font-weight: 600;
  line-height: 1.7;
  letter-spacing: -0.2px;
}

.alert-actions {
  display: flex;
  justify-content: flex-end;
  flex-wrap: wrap;
  gap: 10px;
  flex-shrink: 0;
  margin-top: 25px;
  padding-top: 21px;
  border-top: 1px solid var(--alert-border);
}

.alert-button {
  min-width: 94px;
  min-height: 44px;
  padding: 11px 22px;
  border: 1px solid transparent;
  border-radius: 13px;
  font-size: 13px;
  font-weight: 650;
  line-height: 1.5;
  cursor: pointer;
  transition: background 0.15s, filter 0.15s;
  overflow-wrap: anywhere;
  max-width: 100%;
}

.alert-cancel {
  color: var(--alert-text);
  background: var(--alert-secondary);
  border-color: var(--alert-border);
}

.alert-cancel:hover {
  background: var(--alert-secondary-hover);
}

.alert-confirm {
  color: #fff;
  background: var(--alert-action);
  box-shadow: 0 4px 10px rgba(38, 75, 122, 0.0784313725);
}

.alert-confirm:hover {
  filter: brightness(1.08);
}

.alert-button:focus-visible {
  outline: 2px solid var(--alert-accent);
  outline-offset: 3px;
}

:host-context(.dark) {
  --alert-surface: #172337;
  --alert-border: #2a3b53;
  --alert-title: #edf3fc;
  --alert-text: #a9b7cb;
  --alert-secondary: #213047;
  --alert-secondary-hover: #2a3d57;
}
:host-context(.dark) .alert-overlay {
  background: rgba(4, 12, 24, 0.56);
}
:host-context(.dark) .alert-dialog {
  --alert-tint: #233e57;
  --alert-accent: #8ec8ee;
}
:host-context(.dark) .alert-dialog[data-status=success] {
  --alert-tint: #203f39;
  --alert-accent: #8bd2b5;
}
:host-context(.dark) .alert-dialog[data-status=warning] {
  --alert-tint: #443a2b;
  --alert-accent: #e9c283;
}
:host-context(.dark) .alert-dialog[data-status=error] {
  --alert-tint: #442f3b;
  --alert-accent: #f0a7ad;
}

@keyframes alert-appear {
  from {
    opacity: 0;
    transform: translateY(6px) scale(0.985);
  }
  to {
    opacity: 1;
    transform: none;
  }
}
@media (max-width: 480px) {
  .alert-dialog {
    padding: 23px 20px 20px;
    border-radius: 21px;
  }
  .alert-content {
    gap: 13px;
  }
  .alert-symbol {
    flex-basis: 44px;
    width: 44px;
    height: 44px;
    border-radius: 14px;
  }
  .alert-symbol svg {
    width: 25px;
    height: 25px;
  }
  .alert-message.is-standalone {
    font-size: 15px;
    padding-top: 5px;
  }
  .alert-actions {
    margin-top: 22px;
    padding-top: 18px;
  }
  .alert-button {
    flex: 1;
  }
}
@media (prefers-reduced-motion: reduce) {
  .alert-dialog {
    animation: none;
  }
  .alert-button {
    transition: none;
  }
}`],
})
export class ComponentAlertComponent implements DoCheck, AfterViewChecked, OnDestroy {
    @Input() model: any = null;
    @ViewChild('dialog') dialog: ElementRef<HTMLElement>;
    public dialogId = `gsdc-alert-${++nextAlertId}`;
    private wasOpen = false;
    private needsFocus = false;
    private returnFocus: HTMLElement = null;

    constructor(@Inject( Service) public service: Service) { }

    public get alert(): any { return this.model || this.service.alert; }
    public get status(): string {
        const status = this.alert?.opts?.status;
        return ['success', 'warning', 'error'].includes(status) ? status : 'info';
    }

    public ngDoCheck() {
        const open = !!this.alert?.isshow;
        if (open && !this.wasOpen) {
            this.returnFocus = document.activeElement as HTMLElement;
            this.needsFocus = true;
        } else if (!open && this.wasOpen) {
            this.restoreFocus();
        }
        this.wasOpen = open;
    }

    public ngAfterViewChecked() {
        if (this.needsFocus && this.dialog) {
            this.needsFocus = false;
            this.focusFirst();
        }
    }

    private focusFirst() {
        const dialog = this.dialog?.nativeElement;
        // Focus cancellation first when a choice is presented.
        const first = dialog?.querySelector<HTMLElement>('.alert-cancel, .alert-confirm');
        (first || dialog)?.focus({ preventScroll: true });
    }

    private restoreFocus() {
        this.needsFocus = false;
        if (this.returnFocus?.isConnected) this.returnFocus.focus({ preventScroll: true });
        this.returnFocus = null;
    }

    public ngOnDestroy() { this.restoreFocus(); }

    @HostListener('document:keydown', ['$event'])
    public onKeydown(event: KeyboardEvent) {
        if (!this.alert?.isshow || !this.dialog) return;
        if (event.key === 'Escape' && this.alert.opts.cancel) {
            event.preventDefault();
            event.stopPropagation();
            this.alert.hide();
        } else if (event.key === 'Tab') {
            const dialog = this.dialog.nativeElement;
            const buttons = Array.from(dialog.querySelectorAll<HTMLButtonElement>('button:not([disabled])'));
            const index = buttons.indexOf(document.activeElement as HTMLButtonElement);
            if (!buttons.length) {
                event.preventDefault();
                dialog.focus();
            } else if (event.shiftKey && index <= 0) {
                event.preventDefault();
                buttons[buttons.length - 1].focus();
            } else if (!event.shiftKey && (index < 0 || index === buttons.length - 1)) {
                event.preventDefault();
                buttons[0].focus();
            }
        }
    }

    @HostListener('document:focusin', ['$event'])
    public onFocusIn(event: FocusEvent) {
        if (this.alert?.isshow && this.dialog && !this.dialog.nativeElement.contains(event.target as Node)) {
            this.focusFirst();
        }
    }
}

export default ComponentAlertComponent;